import { render, staticRenderFns } from "./AddDebitCard.vue?vue&type=template&id=5b27f0b6&"
import script from "./AddDebitCard.vue?vue&type=script&lang=js&"
export * from "./AddDebitCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports